import { n as c } from "../property-4FoNj0Pi.js";
import { c as u } from "../lit-element-8JrrHldg.js";
import { u as b, s as P } from "../static-CPcCYSrK.js";
import { o as h } from "../if-defined-Cd-e8xtV.js";
import { o as w } from "../style-map-F8T0o2lr.js";
import { c as _ } from "../clsx-DB4S2d7J.js";
import { I as y } from "../IdController-Cpj_A6H5.js";
import { P as $ } from "../pwc-element-CZs0VuUW.js";
var g = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (o, r, a, s) => {
  for (var e = s > 1 ? void 0 : s ? v(r, a) : r, i = o.length - 1, p; i >= 0; i--)
    (p = o[i]) && (e = (s ? p(r, a, e) : p(e)) || e);
  return s && e && g(r, a, e), e;
};
const m = "pwc-label";
let t = class extends $ {
  constructor() {
    super(...arguments), this.tag = "label", this.idController = new y(this, {
      base: "PwcLabel",
      children: ["label", "description"]
    }), this.slotControlled = ["default", "description"];
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    const {
      description: o,
      for: r,
      idController: {
        child: { description: a, label: s }
      },
      slotted: e,
      tag: i = "label",
      disabled: p,
      required: f
    } = this, n = P(i), d = e.description || (o == null ? void 0 : o.length);
    return b`
      <div class="PwcLabel ${_({
      "PwcLabel--empty": !e.default,
      "PwcLabel--described": d,
      "PwcLabel--disabled": p
    })}">
        <${n} class="PwcLabel__label" for="${h(r)}" id="${s}">
          <p-slot .host=${this}></p-slot>${f ? b`<span class="PwcLabel__required">*</span>` : ""}
        </${n}>
        <span
          class="PwcLabel__description"
          id=${a}
          style=${w({
      display: d ? void 0 : "none !important"
    })}
        >
          <p-slot .host=${this} name="description"></p-slot>${!e.description && o || ""}
        </span>
      </div>
    `;
  }
};
t.tagName = m;
l([
  c({ type: String })
], t.prototype, "description", 2);
l([
  c({ type: String, reflect: !0 })
], t.prototype, "for", 2);
l([
  c({ type: String })
], t.prototype, "tag", 2);
l([
  c({ type: Boolean })
], t.prototype, "disabled", 2);
l([
  c({ type: Boolean })
], t.prototype, "required", 2);
t = l([
  u(m)
], t);
export {
  t as PwcLabel
};
